import styled from"@emotion/styled";export const TutorialDescription=styled.div`
  font-weight: 400;
  font-size: 16px;
  color: ${props=>props.theme.colors.neutral700};
`;